/* eslint-disable */
import { api } from './../../api.js';

const state = {
    active_client: null,
    permisos: []
};

const getters = {
    getActiveClient : (state) => {
        return state.active_client;
    },
    getPermisos : (state) => {
        return state.permisos;
    },
}

const mutations = {
    setActiveClient : (state, active_client) => {
        state.active_client = active_client;
    },
    setPermisos : (state, permisos) => {
        state.permisos = permisos;
    },
}

const actions = {
    getActiveClient: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('agents/active/client', {}).then((res) => {
                commit('setActiveClient', res.data.id);
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateClienteActivo: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('agents/active/client/' + data.cliente_id, {}).then((res) => {
                var permisos = res.data.permissions;
                var per = [];
                for (var i = 0; i < permisos.length; i++) {
                    per.push(permisos[i].name);
                }
                commit('setPermisos', per);
                commit('setActiveClient', data.cliente_id);
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getSelectClientsAgent: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('clients/agent/select', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteClientAgent: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('agents/' + data.id + '/clients/delete', {
                client_id: data.client_id
            }).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    addClientAgent: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('agents/' + data.id + '/clients/add', {
                client_id: data.client_id
            }).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClientsAgentSelect: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('agents/' + data.id + '/clients/select', {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getClientsAgent: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('agents/' + data.id + '/clients', data.params).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateAgent : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('agents/' + data.id, data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAgent : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('agents/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    createAgent : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('agents', data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAgents : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('agents', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteAgent: function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('agents/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/AgentsModule.js